// component
import SvgColor from '../../../components/svg-color';

// ----------------------------------------------------------------------

const icon = (name) => (
    <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />
);

const navConfig =
    process.env.REACT_APP_NAME === 'olybet'
        ? [
              {
                  title: 'Pickems',
                  path: '/dashboard/pickems',
                  icon: icon('ic_analytics'),
              },
              {
                  title: 'Pages',
                  path: '/dashboard/pages',
                  icon: icon('file-text-outline'),
              },
              {
                  title: 'Custom Leagues',
                  path: '/dashboard/leagues',
                  icon: icon('shield-outline'),
              },
              {
                  title: 'Friends Leagues',
                  path: '/dashboard/friends-leagues',
                  icon: icon('people-outline'),
              },
              {
                  title: 'Image Library',
                  path: '/dashboard/image-library',
                  icon: icon('image-outline'),
              },
              {
                  title: 'Banners',
                  path: '/dashboard/banners',
                  icon: icon('image-outline'),
              },
          ]
        : [
              {
                  title: 'Pickems',
                  path: '/dashboard/pickems',
                  icon: icon('ic_analytics'),
              },
              {
                  title: 'Pages',
                  path: '/dashboard/pages',
                  icon: icon('file-text-outline'),
              },
              {
                  title: 'Custom Leagues',
                  path: '/dashboard/leagues',
                  icon: icon('shield-outline'),
              },
              {
                  title: 'Friends Leagues',
                  path: '/dashboard/friends-leagues',
                  icon: icon('people-outline'),
              },
              {
                  title: 'Image Library',
                  path: '/dashboard/image-library',
                  icon: icon('image-outline'),
              },
              {
                  title: 'Banners',
                  path: '/dashboard/banners',
                  icon: icon('image-outline'),
              },
              {
                  title: 'Players Stats',
                  path: '/dashboard/stats',
                  icon: icon('pantone-outline'),
              },
              {
                  title: 'Goalies',
                  path: '/dashboard/fixtures-squad',
                  icon: icon('lock-outline'),
              },
              // {
              //     title: 'user',
              //     path: '/dashboard/user',
              //     icon: icon('ic_user'),
              // },
              // {
              //     title: 'product',
              //     path: '/dashboard/products',
              //     icon: icon('ic_cart'),
              // },
              // {
              //     title: 'blog',
              //     path: '/dashboard/blog',
              //     icon: icon('ic_blog'),
              // },
              // {
              //     title: 'login',
              //     path: '/login',
              //     icon: icon('ic_lock'),
              // },
              // {
              //     title: 'Not found',
              //     path: '/404',
              //     icon: icon('ic_disabled'),
              // },
          ];

export default navConfig;
